import { Link, useNavigate } from 'react-router';
import React, { useState, useEffect, useRef } from "react";
import axios, { axiosSpring } from "../Hooks/axios";
import useAuth from "../Hooks/auth/useAuth";
import { showError, showSuccess } from "../services/reactToastify";
import emailjs from '@emailjs/browser';

function Login() {
  const { auth, setAuth } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  // States for Forgot Password Modal / Step View
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [step, setStep] = useState(1); // 1: Send OTP, 2: Verify OTP & New Password
  const [inputOtp, setInputOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // console.log(email, password)
  const EMAIL =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const PASSWORD =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const [validemail, setValidemail] = useState(true);
  // const [validpassword, setValidpassword] = useState(true);
  const [errMsg, setErrMsg] = useState("");
  // const [user, setUser] = useState("");

  useEffect(() => {
    setValidemail(EMAIL.test(email));
  }, [email]);
  // useEffect(() => {
  //   setValidpassword(PASSWORD.test(password));
  // }, [password]);

  // useEffect(() => {
  //   setErrMsg("");
  // }, [email, password])

  const handleSubmit = async (e) => {

    e.preventDefault();
    const v1 = EMAIL.test(email);
    // const v2 = PASSWORD.test(password);
    if (!v1) {
      setErrMsg("Invalid email or password");
      return;
    }
    // navigate('/home');
    // console.log(password)
    try {
      const response = await axios.post(
        'api/auth/login',
        JSON.stringify({
          email,
          password,
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      // console.log(response?.data);
      const accessToken = response?.data?.accessToken;
      const user = response?.data?.user
      setAuth({
        accessToken: accessToken,
        user: user,
      });
      setEmail("");
      setPassword("");
      showSuccess("Login successful!");
      navigate(`/dashboard`);
    } catch (err) {
      // console.log(err)
      if (!err?.response) {
        setErrMsg("No Server Response");
        showError("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
        showError("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
        showError("Unauthorized")
      } else {
        setErrMsg("Login Failed");
        showError("Wrong Username or password")
      }

    }

  }
  // console.log(auth)
  // --- Frontend-Only Forgot Password Handlers ---
  const handleSendOtp = async (e) => {
    e.preventDefault();
    // Generate a random 6-digit OTP
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOtp(otp);

    // Save target email temporarily in localStorage to update later
    localStorage.setItem("reset_email", email);

    const templateParams = {
      to_email: email,
      otp_code: otp,
    };

    try {
      // Replace with your actual EmailJS Service ID, Template ID, and Public Key
      await emailjs.send(
        'service_5973zra',
        'template_t8b8mqk',
        templateParams,
        'ICWfpNY_pdDOhbEBX'
      );
      showSuccess("OTP sent successfully to your email!");
      setStep(2);
    } catch (err) {
      console.error(err);
      showError("Failed to send OTP via EmailJS.");
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (inputOtp === generatedOtp) {
      showSuccess("OTP verified! Enter your new password.");
      setStep(3);
    } else {
      showError("Invalid OTP. Please try again.");
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    const targetEmail = localStorage.getItem("reset_email");
    
    try {
      await axios.post(
        'api/auth/reset-password',
        JSON.stringify({ email: targetEmail, newPassword: newPassword }),
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      
      showSuccess("Password successfully updated! Please sign in.");
      
      setIsForgotPassword(false);
      setStep(1);
      setEmail("");
      setOtp("");
      setNewPassword("");
      localStorage.removeItem("reset_email");
    } catch (err) {
      // showError("Failed to update password on server.");
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = "http://localhost:8080/oauth2/authorization/google";
  };
  const checkSubmit = email && password
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-6 py-14">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-violet-600 rounded-2xl flex items-center justify-center text-white text-3xl font-bold">A</div>
            <span className="text-3xl font-semibold tracking-tight text-white"><Link to='/'>AetherForge</Link></span>
          </div>
        </div>
        {/* Error Message */}
        {/* {errMsg && (
          <div
            ref={errRef}
            className="mb-6 bg-red-900/30 border border-red-700 text-red-400 px-4 py-3 rounded-2xl text-sm"
            aria-live="assertive"
          >
            {errMsg}
          </div>
        )} */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-10 shadow-2xl">
        {!isForgotPassword ? (
          <>
          <h2 className="text-3xl font-semibold text-violet-600 text-center mb-2">Welcome back</h2>
          <p className="text-zinc-400 text-center mb-8">Sign in to continue to AetherForge</p>

          <form className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                placeholder="you@company.com"
              />
              <label className="block text-sm font-medium text-red-500 mb-2">{email && !validemail ? "* Invalid Email" : ""}</label>
            </div>

            <div>
              <label className="block text-sm font-medium text-zinc-400 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>

            <div className="flex items-center justify-end">
                  <button 
                    type="button" 
                    onClick={() => setIsForgotPassword(true)} 
                    className="text-sm text-violet-400 hover:text-violet-300 bg-transparent border-none cursor-pointer"
                  >
                    Forgot password?
                  </button>
            </div>

            <button
              type="submit"
              className="w-full cursor-pointer bg-violet-600 hover:bg-violet-500 py-4 rounded-2xl font-semibold text-lg transition-all"
              disabled={!checkSubmit} onClick={handleSubmit}
            >
              Sign In
            </button>
          </form>

          <p className="text-center text-zinc-400 mt-8">
            Don't have an account?{' '}
            <a href="/register" className="text-violet-400 hover:text-violet-300 font-medium">Register</a>
          </p>
          </>
          ) : (
            /* Multi-step Frontend Forgot Password Flow */
            <div>
              <h2 className="text-2xl font-semibold text-violet-600 text-center mb-2">Reset Password</h2>
              <p className="text-zinc-400 text-center mb-6 text-sm">
                {step === 1 && "Enter your email address to receive an OTP."}
                {step === 2 && "Enter the 6-digit OTP sent to your email."}
                {step === 3 && "Create your new password."}
              </p>

              {step === 1 && (
                <form onSubmit={handleSendOtp} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-zinc-400 mb-2">Email Address</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                      placeholder="you@company.com"
                      required
                    />
                  </div>
                  <button type="submit" className="w-full cursor-pointer bg-violet-600 hover:bg-violet-500 py-4 rounded-2xl font-semibold text-lg text-white transition-all">
                    Send OTP
                  </button>
                </form>
              )}

              {step === 2 && (
                <form onSubmit={handleVerifyOtp} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-zinc-400 mb-2">Enter OTP</label>
                    <input
                      type="text"
                      value={inputOtp}
                      onChange={(e) => setInputOtp(e.target.value)}
                      className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors tracking-widest text-center text-lg"
                      placeholder="123456"
                      required
                    />
                  </div>
                  <button type="submit" className="w-full cursor-pointer bg-violet-600 hover:bg-violet-500 py-4 rounded-2xl font-semibold text-lg text-white transition-all">
                    Verify OTP
                  </button>
                </form>
              )}

              {step === 3 && (
                <form onSubmit={handleUpdatePassword} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-zinc-400 mb-2">New Password</label>
                    <input
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="w-full text-white bg-zinc-950 border border-zinc-700 focus:border-violet-500 rounded-2xl px-5 py-4 outline-none transition-colors"
                      placeholder="••••••••"
                      required
                    />
                  </div>
                  <button type="submit" className="w-full cursor-pointer bg-violet-600 hover:bg-violet-500 py-4 rounded-2xl font-semibold text-lg text-white transition-all">
                    Update Password
                  </button>
                </form>
              )}

              <button
                type="button"
                onClick={() => { setIsForgotPassword(false); setStep(1); }}
                className="w-full mt-4 text-center text-sm text-zinc-400 hover:text-white bg-transparent border-none cursor-pointer"
              >
                Back to Sign In
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;